module.exports = __webpack_public_path__ + "static/media/26UNRWA25.33edf9d4.jpg";